module.exports = __webpack_public_path__ + "media/markers/default@2x-7fa8f7bf.png";